import type { FunctionComponent } from 'react';

export const CheckCircleIcon: FunctionComponent = () => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
                clipRule="evenodd"
                d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM5.27393 8.7107L6.70968 10.1464C6.90494 10.3417 7.22152 10.3417 7.41679 10.1464L10.7261 6.83716C10.9213 6.6419 10.9213 6.32531 10.7261 6.13005L10.4496 5.85355C10.2543 5.65829 9.93773 5.65829 9.74247 5.85355L7.06323 8.53279L6.25753 7.72709C6.06227 7.53183 5.74569 7.53183 5.55043 7.72709L5.27393 8.00359C5.07867 8.19885 5.07867 8.51543 5.27393 8.7107Z"
                fill="var(--semantic-accent)"
                fillRule="evenodd"
            />
        </svg>
    );
};
